module.exports = __webpack_public_path__ + "img/yslogo.91c887ee.png";